<template>
    <div id="Section-01" class="section-01 wsl-flex-center-ng">
        <div class="container">
            <div class="wsl-show-sm wsl-show-xs">
                <div class="cb-bg-blue block-header wsl-p-y-10">
                    <div class="wsl-flex-middle-ng">
                        <div class="Oswald-Regular wsl-bg-white cb-cyan t24 wsl-flex-center-middle-ng wsl-p-x-6">01</div>
                        <div class="Oswald-Regular cb-cyan t24 wsl-m-l-15">О компании</div>

                        <div class="Oswald-Light cb-white t24 wsl-m-l-auto wsl-m-r-10 wsl-hide-xs">Преимущества</div>
                        <div class="Oswald-Light cb-cyan t24 wsl-hide-xs">CenterBooking.ru</div>
                    </div>
                </div>
            </div>
            <div class="wsl-show-xs wsl-p-x-25 wsl-p-t-20 wsl-relative">
                <!--<div class="wsl-abs wsl-w-100 wsl-h-100"
                     :style="{backgroundImage: `url(${dottedLinesV}`}"
                     style="
                        background-repeat: no-repeat;
                        background-position: right center;
                        top: 0; right: 45px;"></div>-->
                <div class="wsl-m-b-20">
                    <img alt="" src="../assets/img/s01-1.png">
                    <span class="Oswald-Light cb-blue t36 wsl-m-l-10">Надежность</span>
                    <div class="Roboto t16 cb-grey">более 10-ти лет успешной работы позволили объединить
                        более
                        4 000 турагентств по всей России, более 200 туроператоров и более 300
                        авиакомпаний.
                    </div>
                </div>
                <div class="wsl-m-b-20">
                    <img alt="" src="../assets/img/s01-2.png">
                    <span class="Oswald-Light cb-blue t36 wsl-m-l-10">Выгода</span>
                    <div class="Roboto t16 cb-grey">максимальные комиссии на туры, авиабилеты без сборов
                        и
                        доплат + бонусы с первого дня работы. Бесплатно.
                    </div>
                </div>
                <div class="wsl-m-b-20">
                    <img alt="" src="../assets/img/s01-3.png">
                    <span class="Oswald-Light cb-blue t36 wsl-m-l-10">Спокойствие</span>
                    <div class="Roboto t16 cb-grey">выбор надежных вариантов оплаты: крупнейшие банки -
                        партнеры, платежные системы для вас и ваших туристов.
                    </div>
                </div>
                <div class="wsl-m-b-20">
                    <img alt="" src="../assets/img/s01-4.png">
                    <span class="Oswald-Light cb-blue t36 wsl-m-l-10">Удобство</span>
                    <div class="Roboto t16 cb-grey">единый договор для бронирования 200 туроператоров,
                        300 авиакомпаний и 100000 отелей в режиме 24 часа / 7 дней в неделю.
                    </div>
                </div>
                <div class="wsl-m-b-20">
                    <img alt="" src="../assets/img/s01-5.png">
                    <span class="Oswald-Light cb-blue t36 wsl-m-l-10">Работа в регионах</span>
                    <div class="Roboto t16 cb-grey">сеть региональных офисов, позволяющая сотрудничать с
                        CenterBooking.ru из любого уголка России, в том числе оплачивая услуги удаленно.
                    </div>
                </div>
            </div>

            <div class="wsl-flex-ng">
                <div class="wsl-relative wsl-hide-sm wsl-hide-xs" style="width: 37.46%;">
                    <div class="wsl-abs"
                         :style="{backgroundImage: `url(${s01Bg1}`}"
                         style="
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: bottom center;
                    top: 19.3%; right: 0; width: 91.8%; height: 75%;"></div>
                    <div class="wsl-abs"
                         :style="{backgroundImage: `url(${s01Bg2}`}"
                         style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: top left;
                    top: 0; left: 0; width: 88.8%; height: 70.67%;">
                        <div class="wsl-w-100 wsl-h-100 wsl-relative">
                            <div class="wsl-abs wsl-abs-top wsl-flex-middle-ng" style="top: 7%; left: 16.45%;">
                                <div class="Oswald-Regular wsl-bg-white cb-cyan t30 wsl-flex-center-middle-ng wsl-p-x-6">
                                    01
                                </div>
                                <div class="Oswald-Regular cb-cyan t30 wsl-m-l-15">О компании</div>
                            </div>

                            <div class="wsl-abs wsl-abs-bottom wsl-w-100" style="bottom: 23.4%;">
                                <div class="" style="line-height: 1.25; padding-left: 18.5%;">
                                    <div class="Oswald-Light cb-white t48">Преимущества</div>
                                    <div class="Oswald-Light cb-cyan t48">CenterBooking.ru</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="wsl-col wsl-hide-xs">
                    <div class="sec-01-wrap" style="padding-left: 48px; padding-right: 70px;">
                        <div class="wsl-flex-ng">
                            <div class="wsl-relative" style="width: 46.1%;">
                                <div class="wsl-flex-right-nowrap-ng wsl-abs" style="margin-top: 50px;">
                                    <div class="wsl-p-r-5">
                                        <img alt="" src="../assets/img/s01-1.png">
                                        <span class="Oswald-Light cb-blue t36 wsl-m-l-10">Надежность</span>
                                        <div class="Roboto t16 cb-grey">более 10-ти лет успешной работы позволили объединить
                                            более
                                            4 000 турагентств по всей России, более 200 туроператоров и более 300
                                            авиакомпаний.
                                        </div>
                                    </div>
                                    <div    :style="{backgroundImage: `url(${dottedLinesH}`}"
                                            style="
                                        width: 90px; height: 18px; margin-top: 30px;"></div>
                                </div>

                                <div class="wsl-flex-right-nowrap-ng wsl-abs" style="margin-top: 332px;">
                                    <div class="wsl-p-r-5">
                                        <img alt="" src="../assets/img/s01-3.png">
                                        <span class="Oswald-Light cb-blue t36 wsl-m-l-10">Спокойствие</span>
                                        <div class="Roboto t16 cb-grey">выбор надежных вариантов оплаты: крупнейшие банки -
                                            партнеры, платежные системы для вас и ваших туристов.
                                        </div>
                                    </div>
                                    <div    :style="{backgroundImage: `url(${dottedLinesH}`}"
                                            style="
                                        width: 90px; height: 18px; margin-top: 30px;"></div>
                                </div>

                                <div class="wsl-flex-right-nowrap-ng wsl-abs" style="margin-top: 600px;">
                                    <div class="wsl-p-r-5">
                                        <img alt="" src="../assets/img/s01-5.png">
                                        <span class="Oswald-Light cb-blue t36 wsl-m-l-10">Работа в регионах</span>
                                        <div class="Roboto t16 cb-grey">сеть региональных офисов, позволяющая сотрудничать с
                                            CenterBooking.ru из любого уголка России, в том числе оплачивая услуги удаленно.
                                        </div>
                                    </div>
                                    <div    :style="{backgroundImage: `url(${dottedLinesH}`}"
                                            style="
                                        width: 90px; height: 18px; margin-top: 30px;"></div>
                                </div>
                            </div>

                            <div    :style="{backgroundImage: `url(${dottedLinesV}`}"
                                    style="
                                 width: 24px; height: 815px;"></div>

                            <div class="wsl-col wsl-relative">
                                <div class="wsl-flex-nowrap-ng wsl-abs" style="margin-top: 200px;">
                                    <div    :style="{backgroundImage: `url(${dottedLinesH}`}"
                                            style="
                                        width: 90px; height: 18px; margin-top: 32px;"></div>
                                    <div class="wsl-p-l-5" style="margin-top: 0px;">
                                        <img alt="" src="../assets/img/s01-2.png">
                                        <span class="Oswald-Light cb-blue t36 wsl-m-l-10">Выгода</span>
                                        <div class="Roboto t16 cb-grey">максимальные комиссии на туры, авиабилеты без сборов
                                            и
                                            доплат + бонусы с первого дня работы. Бесплатно.
                                        </div>
                                    </div>
                                </div>

                                <div class="wsl-flex-nowrap-ng wsl-abs" style="margin-top: 465px;">
                                    <div    :style="{backgroundImage: `url(${dottedLinesH}`}"
                                            style="
                                        width: 90px; height: 18px; margin-top: 32px;"></div>
                                    <div class="wsl-p-l-5" style="margin-top: 0px;">
                                        <img alt="" src="../assets/img/s01-4.png">
                                        <span class="Oswald-Light cb-blue t36 wsl-m-l-10">Удобство</span>
                                        <div class="Roboto t16 cb-grey">единый договор для бронирования 200 туроператоров,
                                            300 авиакомпаний и 100000 отелей в режиме 24 часа / 7 дней в неделю.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Section-01',
  props: {
    dottedLinesV: String,
    dottedLinesH: String,
    s01Bg1: String,
    s01Bg2: String
  }
}
</script>

<style scoped>

</style>
